import { render, staticRenderFns } from "./EntradaDaEdicaoDeLoja.vue?vue&type=template&id=5c6a57c0&"
import script from "./EntradaDaEdicaoDeLoja.vue?vue&type=script&lang=ts&"
export * from "./EntradaDaEdicaoDeLoja.vue?vue&type=script&lang=ts&"
import style0 from "./estilos-da-tela-de-loja.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
